import SubLabel from "components/Atoms/Sublabel";
import { FormSection } from "components/MainSectionTemplate/types";
import CompanyModalPicker from "components/Picker/CompanyPicker/CompanyModalPicker";
import ContactModalPicker from "components/Picker/ContactPicker/ContactModalPicker";
import { ContactSidePanel } from "components/SidePanel/contact/ContactSidePanel";
import { CompanySmallDetails } from "components/SmallDetails";
import React from "react";
import { useContact } from "utilities/api/contactQuery";

interface Props {
  contact: server.dto.ContactSmallV2
  contactEmail: string
  company: server.dto.CompanySmall
  clientId: number
}

export const billingDetailsSection = (props: Props): FormSection => {
  const { contact, contactEmail, company, clientId } = props
  return {
    key: "billingDetails",
    type: "regular",
    title: "Billing details",
    fields: [
      {
        key: "billingCompany",
        label: "Company",
        render: () => <CompanySmallDetails
          company={company}
          layout="multiLine" />,
        inPageEdit: {
          hoverEdit: true,
          render: ({ onChange, cancel, value }) => <div className="main-section-template-fields-padding">
            <CompanyModalPicker
              afterCreate="closeSidebar"
              modalTitle="Select company"
              addressType="administrative"
              inPageEditing={{ onChange, cancel, hasValue: Boolean(value) }}
              canCreateNew
            />
          </div>,
          fullWidth: false,
          type: "custom",
          initialValue: company,
          submitChange: async (c) => window.CoreApi.Client.UpdateCompany({ companyId: c.companyId, clientId })
        }
      }, {
        key: "billingContact",
        label: "Finance contact",
        render: () => <ContactRow contact={contact} email={contactEmail} />,
        inPageEdit: {
          hoverEdit: true,
          render: ({ onChange, cancel, value }) => <div className="main-section-template-fields-padding">
            <ContactModalPicker
              inPageEditing={{ onChange, cancel, hasValue: Boolean(value) }}
              canCreateNew={false}
            />
          </div>,
          fullWidth: false,
          type: "custom",
          initialValue: contact,
          submitChange: async (c) => window.CoreApi.Client.UpdateContact({ contactId: c.contactId, clientId })
        }
      }
    ]
  }
}

const ContactRow = (props: { contact: server.dto.ContactSmallV2, email: string }) => {
  const contact = useContact(props.contact);
  return <div>
    <div>
      <ContactSidePanel contactId={contact.contactId} trigger={<a>{contact.name.fullName}</a>} />
    </div>
    <SubLabel>{props.email}</SubLabel>
  </div>
}
